/* eslint-disable */
import { nanoid } from "@reduxjs/toolkit";
import "./mainSelect.scss";

const MainSelect = ({
  handleChange,
  options = [],
	type="",
  selectName = "selectName",
  selectID = "selectID",
}) => {

  return (
    <div className="main_select">
      <select onChange={handleChange} name={selectName} id={selectID} value={type}>
        {options.map((item) => (
          <option value={item.value} key={nanoid()}>
            {item.text}
          </option>
        ))}
      </select>
    </div>

		 
  );
};

export default MainSelect;
